var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$attrs["label-postion"] == "left"
    ? _c(
        "el-form-item",
        {
          attrs: {
            "label-width": _vm.$attrs["label-width"],
            prop: _vm.$attrs["prop"],
            label: _vm.$attrs["label"],
          },
        },
        [
          _c("el-checkbox", {
            attrs: { disabled: _vm.$attrs["disabled"] },
            on: { change: _vm.onChange },
            model: {
              value: _vm.innerValue,
              callback: function ($$v) {
                _vm.innerValue = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "innerValue",
            },
          }),
        ],
        1
      )
    : _c(
        "el-form-item",
        {
          attrs: {
            "label-width": _vm.$attrs["label-width"],
            prop: _vm.$attrs["prop"],
          },
        },
        [
          _c("el-checkbox", {
            attrs: {
              label: _vm.$attrs["label"],
              disabled: _vm.$attrs["disabled"],
            },
            on: { change: _vm.onChange },
            model: {
              value: _vm.innerValue,
              callback: function ($$v) {
                _vm.innerValue = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "innerValue",
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }